import {useEffect, useState} from 'react'
import {Button, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  url: string
}

export const ModalViewUrl: React.FC<IModalProps> = ({isOpen, onClose, url}) => {
  const [isCopy, setIsCopy] = useState(false)

  useEffect(() => {
    let time: NodeJS.Timeout
    if (isCopy) {
      time = setTimeout(() => {
        setIsCopy(false)
      }, 650)
    }
    return () => {
      clearTimeout(time)
    }
  }, [isCopy])

  const handleCopy = () => {
    navigator.clipboard.writeText(url)
    setIsCopy(true)
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header onHide={onClose}>
        <Modal.Title>¡Éxito!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='fs-3 pb-3 mb-4'>Url generada correctamente</p>
        <div className='d-flex align-items-center gap-3 justify-content-around w-100'>
          <OverlayTrigger
            placement='top'
            overlay={
              <Tooltip id={`tooltip-top`}>
                <p className='text-center fw-bold m-0 p-0'>
                  {isCopy ? 'Texto copiado ✅' : 'Copiar'}
                </p>
              </Tooltip>
            }
          >
            <Button variant='dark' onClick={handleCopy}>
              <i className='bi bi-clipboard fs-3' style={{color: 'inherit'}} />
              Copiar
            </Button>
          </OverlayTrigger>
          <a href={url} target='_blank' rel='noopener noreferrer' className='btn btn-info'>
            <i className='bi bi-box-arrow-up-right fs-3' style={{color: 'inherit'}} />
            Ir
          </a>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant='light'>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
